import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Models the UAUserPermissions
 *
 * @class UAUserPermissions
 */

var UAUserPermissions =
/**
 * Creates an instance of UAUserPermissions.
 * @param {*} json
 * @memberof UAUserPermissions
 */
function UAUserPermissions() {
  var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  _classCallCheck(this, UAUserPermissions);

  if (json) {
    // boolean
    this.canAppeal = json.canAppeal;
  }
};
/**
 * Models the UAUserInformation
 *
 * @class UAUserInformation
 */


var UAUserInformation =
/**
 * Creates an instance of UAUserInformation.
 * @param {*} json
 * @memberof UAUserInformation
 */
function UAUserInformation() {
  var json = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  _classCallCheck(this, UAUserInformation);

  if (json) {
    // object - UAUserPermissions
    if (json.permissions) {
      this.permissions = new UAUserPermissions(json.permissions);
    }
  }
};

export default {
  UAUserPermissions: UAUserPermissions,
  UAUserInformation: UAUserInformation
};